module.exports = __webpack_public_path__ + "img/1561290969.1c74e994.jpg";